import Backbone from 'backbone'
import $ from 'jquery'
import template from 'scoreboard/components/tiles-with-icon-options.hbs'

const TilesWithIconOptions = Backbone.View.extend({
	className: 'tiles-with-icon-options',

	events: {
		'click .tiles li': 'onOptionSelected'
	},

	/**
	 * @constructs
	 * @param {String} [options.defaultValue] the type value for the default option to select
	 * @param {String} [options.labelKey] the i18n key for the label above this group of tiles
	 * @param {Function} [options.tooltipFn] a function that returns the tooltip to display
	 * 									     or null if no tooltip should be displayed
	 * @param {Array<{
	 * 					optionType: String,
	 * 					option: {
	 * 						type: String,
	 * 						icon: String,
	 * 						label: String
	 * 					}
	 * 				}
	 * 			>} [options.sections] the sections that house each set of icons
	 */
	initialize: function(options = {}) {
		this.options = options
		this.selectedType = this.options.defaultValue
	},

	render: function() {
		this.$el.append(template(this.options))
		this.selectDefaultOption()
		return this
	},

	selectDefaultOption: function() {
		this.$(`[data-type="${this.selectedType}"`).addClass('is-selected')
	},

	onOptionSelected: function(e) {
		const target = $(e.currentTarget)

		// show a tooltip if the selected type is not yet implemented
		this.tooltip && this.tooltip.remove()
		this.tooltip = this.options.tooltipFn && this.options.tooltipFn(target)
		if (this.tooltip) {
			// don't change the selection state if the tooltip is not displayed
			return
		}

		// Update the selected styling
		this.$(`[data-type="${this.selectedType}"]`).removeClass('is-selected')
		target.addClass('is-selected')

		this.selectedType = target.data('type')

		this.trigger('option-selected', this.selectedType)
	}
})

export default TilesWithIconOptions
TilesWithIconOptions.__filename__ = 'components/tiles-with-icon-options.js'
